var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid base" }, [
    _c("div", { staticClass: "top-base" }, [
      _c("div", { staticClass: "btns" }, [
        _c("div", { staticClass: "bnts-tipo-ativo" }, [
          _c(
            "div",
            {
              staticClass: "btn-novo-ativo",
              class: { clicado: _vm.selection === _vm.CARTEIRA },
              on: {
                click: function($event) {
                  return _vm.novoOuExistente($event, _vm.CARTEIRA)
                }
              }
            },
            [_c("span", [_vm._v("Carteira")])]
          ),
          _c(
            "div",
            {
              staticClass: "btn-ativo-existente",
              class: { clicado: _vm.selection === _vm.MOVIMENTACAO },
              on: {
                click: function($event) {
                  return _vm.novoOuExistente($event, _vm.MOVIMENTACAO)
                }
              }
            },
            [_c("span", [_vm._v("Movimentação")])]
          ),
          _c(
            "div",
            {
              staticClass: "btn-ativo-extras",
              class: { clicado: _vm.selection === _vm.COTACOES },
              on: {
                click: function($event) {
                  return _vm.novoOuExistente($event, _vm.COTACOES)
                }
              }
            },
            [_c("span", [_vm._v("Cotações")])]
          )
        ])
      ]),
      _c("div", { staticClass: "data" }, [
        _c("div", [_c("span", [_vm._v(_vm._s(_vm.$hoje))])]),
        _c(
          "div",
          [
            _c("v-img", {
              staticClass: "imagem_calendar",
              attrs: { src: require("../../../assets/icons/calendar_icon.svg") }
            })
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "componentes" }, [
      _vm.selection === _vm.CARTEIRA
        ? _c(
            "div",
            { staticClass: "carteira" },
            [
              _c("Carteira", { on: { showMovimentacao: _vm.showMovimentacao } })
            ],
            1
          )
        : _vm._e(),
      _vm.selection === _vm.MOVIMENTACAO
        ? _c(
            "div",
            { staticClass: "movimentacao" },
            [_c("Movimentacao", { attrs: { movimentacao: _vm.movimentacao } })],
            1
          )
        : _vm._e(),
      _vm.selection === _vm.COTACOES
        ? _c("div", { staticClass: "cotacoes" }, [_c("PgCotacoes")], 1)
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }